// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import * as React from 'react';

import styled, { CSSObject } from '@emotion/styled';

import { disabledColor, primaryColor, unit } from '@zego/theme';

import CircleBackground from '@zego/components/atoms/CircleBackground';
import RegularText from '@zego/components/atoms/RegularText';
import View from '@zego/components/atoms/View';
import BoldText from '@zego/components/BoldText';

interface ExtraProtectionOfferProps {
  className?: string;
  children: React.ReactNode;
  iconSrc: string;
  title: string;
  description: string;
  detailTitle?: string;
  iconProps?: { width?: number; height?: number };
  css?: CSSObject;
}

function ExtraProtectionOffer({
  children,
  className,
  iconSrc,
  title,
  description,
  detailTitle,
  iconProps,
}: ExtraProtectionOfferProps): JSX.Element {
  return (
    <GreyRoundedBox
      className={className}
      css={{
        marginBottom: unit(2),
      }}
    >
      <View
        css={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          height: '100%',
        }}
      >
        <View>
          <CircleBackground backgroundColor={primaryColor(6)} size={unit(5)}>
            <img
              src={iconSrc}
              alt=""
              width={unit(3.5)}
              height={unit(3.5)}
              {...iconProps}
            />
          </CircleBackground>
        </View>
        <View
          css={{
            marginLeft: unit(3),
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'space-between',
            height: '100%',
          }}
        >
          <View>
            <DarkBoldText
              css={{
                marginTop: unit(0.5),
                marginBottom: unit(1),
                fontSize: '18px',
              }}
            >
              {title}
            </DarkBoldText>
            <RegularText>{description}</RegularText>
          </View>
          <View
            css={{
              display: 'flex',
              flexDirection: 'column',
              paddingTop: unit(2),
              paddingBottom: unit(2),
            }}
          >
            <RegularText css={{ fontSize: '12px' }}>{detailTitle}</RegularText>
            <View
              css={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: unit(0.5),
              }}
            >
              {children}
            </View>
          </View>
        </View>
      </View>
    </GreyRoundedBox>
  );
}

/**
 * Styled components
 */

const GreyRoundedBox = styled(View)({
  border: `1px solid ${disabledColor(4)}`,
  borderRadius: '12px',
  paddingTop: unit(4),
  paddingBottom: unit(4),
  paddingLeft: unit(3),
  paddingRight: unit(4.5),
});

const DarkBoldText = styled(BoldText)({
  color: disabledColor(10),
});

export default ExtraProtectionOffer;
